module.exports = __webpack_public_path__ + "assets/img/lector-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-1.jpg
// module id = 1954
// module chunks = 0